module.exports = __webpack_public_path__ + "media/images/welcome/feature1-1-ee0f03b023dbfc2634364b1831462e5a.png";